module.exports = __webpack_public_path__ + "img/hero-image-02.631ea5d1.png";